<template>
  <b-modal
    ref="warranty-history-detail-modal"
    v-model="showModal"
    size="xl"
    :title="`Chi tiết lịch sử bảo hành - ${id || ''}`"
    header-bg-variant="light"
    @hidden="onModalHidden"
    @show="onModalShow"
    no-close-on-backdrop
    scrollable
  >
    <b-overlay :show="isLoading" rounded="sm">
      <div v-if="!isLoading && historyData">
        <h5 class="bold-text">Thông tin log</h5>
        <hr />
        <b-container class="bv-example-row">
          <b-row class="justify-content-md-center mb-10">
            <b-col>
              <b-row>
                <b-col class="col-md-4">
                  <p class="header-color">Loại log:</p>
                  <p class="header-color">Mã:</p>
                </b-col>
                <b-col>
                  <p>{{ historyData.type }}</p>
                  <p>{{ historyData.id }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-md-4">
                  <p class="header-color">Người sửa:</p>
                  <p class="header-color">IP:</p>
                </b-col>
                <b-col>
                  <p>
                    <b>{{ historyData.updatedBy }}</b>
                  </p>
                  <p>{{ historyData.clientIp }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-md-4">
                  <p class="header-color">Thiết bị:</p>
                </b-col>
                <b-col>
                  <p>
                    <span class="text-muted">
                      OS: {{ historyData.userAgent.osName }}
                    </span>
                  </p>
                  <span class="text-muted">
                    Browser:
                    {{ historyData.userAgent.browserName }}
                  </span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <h5 class="bold-text">Thông tin thay đổi</h5>
        <hr />
        <b-container class="bv-example-row">
          <table
            border="1"
            style="width: 100%"
            class="table table-bordered table-vertical-center table-hover mb-10"
          >
            <colgroup>
              <col style="width: 20%" />
              <col style="width: 40%" />
              <col style="width: 40%" />
            </colgroup>
            <thead class="bg-secondary">
              <tr>
                <th rowspan="2">Thông tin</th>
              </tr>
              <tr>
                <th>Trước khi sửa</th>
                <th>Sau khi sửa</th>
              </tr>
            </thead>
            <tbody v-if="hasDiffInfo">
              <!-- Warranty Fields -->
              <tr v-if="hasFieldDiff('storeName')">
                <th class="header-color">Cửa hàng hiện tại</th>
                <td>{{ getFieldValue('storeName', 'original') }}</td>
                <td>{{ getFieldValue('storeName', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('transferStatusName')">
                <th class="header-color">Trạng thái chuyển</th>
                <td>{{ getFieldValue('transferStatusName', 'original') }}</td>
                <td>{{ getFieldValue('transferStatusName', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('status')">
                <th class="header-color">Trạng thái</th>
                <td>{{ getFieldValue('statusName', 'original') }}</td>
                <td>{{ getFieldValue('statusName', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('warrantyServiceId')">
                <th class="header-color">Loại dịch vụ</th>
                <td>{{ getFieldValue('warrantyServiceName', 'original') }}</td>
                <td>{{ getFieldValue('warrantyServiceName', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('customerName')">
                <th class="header-color">Tên khách hàng</th>
                <td>{{ getFieldValue('customerName', 'original') }}</td>
                <td>{{ getFieldValue('customerName', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('customerPhone')">
                <th class="header-color">Số điện thoại</th>
                <td>{{ getFieldValue('customerPhone', 'original') }}</td>
                <td>{{ getFieldValue('customerPhone', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('customerEmail')">
                <th class="header-color">Email</th>
                <td>{{ getFieldValue('customerEmail', 'original') }}</td>
                <td>{{ getFieldValue('customerEmail', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('customerAddress')">
                <th class="header-color">Địa chỉ</th>
                <td>{{ getFieldValue('customerAddress', 'original') }}</td>
                <td>{{ getFieldValue('customerAddress', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('productName')">
                <th class="header-color">Tên sản phẩm</th>
                <td>{{ getFieldValue('productName', 'original') }}</td>
                <td>{{ getFieldValue('productName', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('imeiCode')">
                <th class="header-color">IMEI/Serial</th>
                <td>{{ getFieldValue('imeiCode', 'original') }}</td>
                <td>{{ getFieldValue('imeiCode', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('estimatedCost')">
                <th class="header-color">Báo giá</th>
                <td>
                  {{ convertPrice(getFieldValue('estimatedCost', 'original')) }}
                </td>
                <td>
                  {{ convertPrice(getFieldValue('estimatedCost', 'current')) }}
                </td>
              </tr>
              <tr v-if="hasFieldDiff('actualCost')">
                <th class="header-color">Tiền thu khách</th>
                <td>
                  {{ convertPrice(getFieldValue('actualCost', 'original')) }}
                </td>
                <td>
                  {{ convertPrice(getFieldValue('actualCost', 'current')) }}
                </td>
              </tr>
              <tr v-if="hasFieldDiff('issueDescription')">
                <th class="header-color">Mô tả lỗi</th>
                <td>{{ getFieldValue('issueDescription', 'original') }}</td>
                <td>{{ getFieldValue('issueDescription', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('externalNote')">
                <th class="header-color">Ngoại quan</th>
                <td>{{ getFieldValue('externalNote', 'original') }}</td>
                <td>{{ getFieldValue('externalNote', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('internalNote')">
                <th class="header-color">Ghi chú nội bộ</th>
                <td>{{ getFieldValue('internalNote', 'original') }}</td>
                <td>{{ getFieldValue('internalNote', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('receiptNumber')">
                <th class="header-color">Số biên bản</th>
                <td>{{ getFieldValue('receiptNumber', 'original') }}</td>
                <td>{{ getFieldValue('receiptNumber', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('trackingNumber')">
                <th class="header-color">Vận đơn</th>
                <td>{{ getFieldValue('trackingNumber', 'original') }}</td>
                <td>{{ getFieldValue('trackingNumber', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('returnCount')">
                <th class="header-color">Số lần quay lại</th>
                <td>{{ getFieldValue('returnCount', 'original') }}</td>
                <td>{{ getFieldValue('returnCount', 'current') }}</td>
              </tr>
              <tr v-if="hasFieldDiff('expectedReturnDate')">
                <th class="header-color">Ngày hẹn trả</th>
                <td>
                  {{
                    formatDate(getFieldValue('expectedReturnDate', 'original'))
                  }}
                </td>
                <td>
                  {{
                    formatDate(getFieldValue('expectedReturnDate', 'current'))
                  }}
                </td>
              </tr>
              <tr v-if="hasFieldDiff('purchaseDate')">
                <th class="header-color">Ngày mua</th>
                <td>
                  {{ formatDate(getFieldValue('purchaseDate', 'original')) }}
                </td>
                <td>
                  {{ formatDate(getFieldValue('purchaseDate', 'current')) }}
                </td>
              </tr>

              <!-- Repair Fields -->
              <template v-if="repairDiffRows.length">
                <tr
                  v-for="(r, idx) in repairDiffRows"
                  :key="`repair-${idx}-${r.sessionIndex}-${r.fieldKey}`"
                >
                  <th class="header-color">
                    Phiên sửa chữa {{ r.sessionIndex + 1 }}
                    <template v-if="r.technicianName">({{ r.technicianName }})</template>
                    - {{ r.fieldLabel }}
                  </th>
                  <td>
                    <template v-if="r.fieldKey === 'repairCost'">
                      {{ convertPrice(r.originalValue) }}
                    </template>
                    <template
                      v-else-if="['startAt', 'estimatedCompletionAt', 'actualCompletionAt'].includes(r.fieldKey)"
                    >
                      {{ formatDateTime(r.originalValue) }}
                    </template>
                    <template v-else>
                      {{ r.originalValue || '' }}
                    </template>
                  </td>
                  <td>
                    <template v-if="r.fieldKey === 'repairCost'">
                      {{ convertPrice(r.currentValue) }}
                    </template>
                    <template
                      v-else-if="['startAt', 'estimatedCompletionAt', 'actualCompletionAt'].includes(r.fieldKey)"
                    >
                      {{ formatDateTime(r.currentValue) }}
                    </template>
                    <template v-else>
                      {{ r.currentValue || '' }}
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </b-container>
      </div>
    </b-overlay>
    <template #modal-footer="{ close }">
      <b-button variant="secondary" size="sm" @click="close()"> Đóng </b-button>
    </template>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { convertPrice } from '@/utils/common';
import { HISTORY_TYPE } from '@/utils/enum';
import { convertToDateSlash } from '@/utils/date';

export default {
  name: 'WarrantyHistoryDetailModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    historyId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      historyData: null,
      id: '',
    };
  },
  computed: {
    hasDiffInfo() {
      return (
        this.historyData &&
        this.historyData.originalValue &&
        this.historyData.newValue
      );
    },
    repairDiffRows() {
      if (!this.hasDiffInfo || !this.historyData) return []
      const { originalSessions, currentSessions } = this._getRepairSessionsForCompare()
      const maxLen = Math.max(originalSessions.length, currentSessions.length)

      const fields = [
        { key: 'repairSolution', label: 'Cách sửa' },
        { key: 'solutionName', label: 'Giải pháp' },
        { key: 'errorGroupName', label: 'Nhóm lỗi' },
        { key: 'errorSeverityName', label: 'Mức độ' },
        { key: 'primaryTechnicianName', label: 'Kỹ thuật viên' },
        { key: 'supportTechnician1Name', label: 'Kỹ thuật viên 2' },
        { key: 'supportTechnician2Name', label: 'Kỹ thuật viên 3' },
        { key: 'startAt', label: 'Thực hiện lúc' },
        { key: 'estimatedCompletionAt', label: 'Thời hạn sửa' },
        { key: 'actualCompletionAt', label: 'Hoàn thành lúc' },
        { key: 'repairCost', label: 'Tiền sửa chữa' },
      ]

      const rows = []
      for (let i = 0; i < maxLen; i++) {
        const o = originalSessions[i] || null
        const c = currentSessions[i] || null
        const technicianName =
          (c && c.primaryTechnicianName) ||
          (o && o.primaryTechnicianName) ||
          (c && c.primaryTechnicianId) ||
          (o && o.primaryTechnicianId) ||
          ''
        fields.forEach((f) => {
          const ov = o ? this._getRepairField(o, f.key) : ''
          const cv = c ? this._getRepairField(c, f.key) : ''
          if (!this._isSameRepairValue(f.key, ov, cv)) {
            rows.push({
              sessionIndex: i,
              technicianName,
              fieldKey: f.key,
              fieldLabel: f.label,
              originalValue: ov,
              currentValue: cv,
            })
          }
        })
      }
      return rows
    },
  },
  watch: {
    show(newVal) {
      this.showModal = newVal;
      if (newVal && this.historyId) {
        this.loadHistoryData();
      }
    },
    showModal(newVal) {
      this.$emit('update:show', newVal);
      if (newVal) {
        this.updateUrlWithModal();
      } else {
        this.removeUrlModal();
      }
    },
  },
  mounted() {
    this.handleModalFromUrl();
    window.addEventListener('popstate', this.handlePopState);
    document.addEventListener('keydown', this.handleEscKey);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
    document.removeEventListener('keydown', this.handleEscKey);
  },
  methods: {
    _getRepairSessionsForCompare() {
      const fromDiff = this._getRepairSessionsFromDiffRepair(this.historyData?.diffRepair)
      if (fromDiff) return fromDiff
      return {
        originalSessions: this._normalizeRepairSessions(this.historyData.originalValue),
        currentSessions: this._normalizeRepairSessions(this.historyData.newValue),
      }
    },
    _getRepairSessionsFromDiffRepair(diffRepair) {
      const list = diffRepair?._
      if (!Array.isArray(list) || list.length === 0) return null

      const originalSessions = []
      const currentSessions = []

      list.forEach((entry) => {
        if (!entry) return

        if (entry.status === 'ADDED') {
          originalSessions.push(entry.original || null)
          currentSessions.push(entry.current || null)
          return
        }
        if (entry.status === 'REMOVED') {
          originalSessions.push(entry.original || null)
          currentSessions.push(entry.current || null)
          return
        }

        // status MODIFIED/EQUAL and has detailed diff at entry._
        const diffFields = entry._
        if (!diffFields || typeof diffFields !== 'object') {
          originalSessions.push(entry.original || null)
          currentSessions.push(entry.current || null)
          return
        }

        const o = {}
        const c = {}
        Object.keys(diffFields).forEach((k) => {
          const d = diffFields[k]
          if (!d || typeof d !== 'object') return
          if ('original' in d) o[k] = d.original
          if ('current' in d) c[k] = d.current
        })
        originalSessions.push(o)
        currentSessions.push(c)
      })

      return { originalSessions, currentSessions }
    },
    _normalizeRepairSessions(value) {
      if (!value) return []
      if (Array.isArray(value.warrantyRepairs)) return value.warrantyRepairs
      if (value.repair) return [value.repair]
      return []
    },
    _getRepairField(session, key) {
      if (!session) return ''
      const v = session[key]
      return v == null ? '' : v
    },
    _isSameRepairValue(key, a, b) {
      if (key === 'repairCost') return Number(a || 0) === Number(b || 0)
      if (['startAt', 'estimatedCompletionAt', 'actualCompletionAt'].includes(key)) {
        return String(a || '') === String(b || '')
      }
      return String(a || '') === String(b || '')
    },
    convertPrice,
    formatDate(date) {
      if (!date) return '';
      if (typeof date === 'string' && date.includes('T')) {
        return convertToDateSlash(date);
      }
      return date;
    },
    formatDateTime(dateTime) {
      if (!dateTime) return '';
      if (typeof dateTime === 'string') {
        const date = new Date(dateTime);
        return date.toLocaleString('vi-VN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        });
      }
      return dateTime;
    },
    getHistoryType(typeId) {
      switch (typeId) {
        case HISTORY_TYPE.WARRANTY:
          return 'Bảo hành';
        default:
          return '';
      }
    },
    async loadHistoryData() {
      if (!this.historyId) return;

      this.isLoading = true;
      this.id = this.historyId;

      try {
        const params = { type: HISTORY_TYPE.WARRANTY };
        const response = await ApiService.query(
          `/v1/histories/${this.historyId}`,
          { params },
        );

        const {
          type,
          action,
          createdByName,
          originalValue,
          newValue,
          userIP: clientIp,
          userAgent: rawUserAgent,
          diffInfo,
          diffRepair,
        } = response.data.data;
        let userAgent = {}
        try {
          userAgent =
            typeof rawUserAgent === 'string' && rawUserAgent
              ? JSON.parse(rawUserAgent)
              : rawUserAgent || {}
        } catch (error) {
          userAgent = {};
        }

        let parsedOriginalValue = originalValue
        let parsedNewValue = newValue
        try {
          parsedOriginalValue =
            typeof originalValue === 'string' && originalValue
              ? JSON.parse(originalValue)
              : originalValue || {}
        } catch (e) {
          parsedOriginalValue = originalValue || {}
        }
        try {
          parsedNewValue =
            typeof newValue === 'string' && newValue ? JSON.parse(newValue) : newValue || {}
        } catch (e) {
          parsedNewValue = newValue || {}
        }

        this.historyData = {
          type: this.getHistoryType(type),
          action,
          id: this.historyId,
          updatedBy: createdByName,
          clientIp,
          originalValue: parsedOriginalValue,
          newValue: parsedNewValue,
          userAgent,
          diffInfo,
          diffRepair,
        };
      } catch (error) {
        console.error('Error loading history data:', error);
      } finally {
        this.isLoading = false;
      }
    },
    hasFieldDiff(fieldName) {
      if (!this.historyData) return false;
      const diff = this.historyData.diffInfo && this.historyData.diffInfo._ && this.historyData.diffInfo._[fieldName];
      if (diff && diff.status) {
        return diff.status !== 'EQUAL';
      }
      if (!this.hasDiffInfo) return false;
      const original = this.historyData.originalValue[fieldName];
      const current = this.historyData.newValue[fieldName];
      return original !== current;
    },
    getFieldValue(fieldName, type) {
      if (!this.hasDiffInfo) return '';

      // Nếu field có trong diffInfo, lấy từ đó
      if (
        this.historyData.diffInfo &&
        this.historyData.diffInfo._ &&
        this.historyData.diffInfo._[fieldName]
      ) {
        const diffField = this.historyData.diffInfo._[fieldName];
        return type === 'original'
          ? diffField.original || ''
          : diffField.current || '';
      }

      // Nếu không có trong diffInfo, lấy từ originalValue/newValue
      const value =
        type === 'original'
          ? this.historyData.originalValue[fieldName]
          : this.historyData.newValue[fieldName];
      return value || '';
    },
    hasRepairFieldDiff(fieldName) {
      if (!this.hasDiffInfo || !this.historyData) return false;
      const repairDiff =
        this.historyData.diffRepair &&
        this.historyData.diffRepair._ &&
        this.historyData.diffRepair._[fieldName];
      if (repairDiff && repairDiff.status) {
        return repairDiff.status !== 'EQUAL';
      }
      return false;
    },
    getRepairFieldValue(fieldName, type) {
      if (!this.hasDiffInfo || !this.historyData) return '';
      const repairDiff =
        this.historyData.diffRepair &&
        this.historyData.diffRepair._ &&
        this.historyData.diffRepair._[fieldName];
      if (repairDiff) {
        return type === 'original'
          ? repairDiff.original ?? ''
          : repairDiff.current ?? '';
      }
      return '';
    },
    onModalShow() {
      this.$emit('show');
    },
    onModalHidden() {
      this.$emit('hidden');
      this.removeUrlModal();
    },
    updateUrlWithModal() {
      if (this.historyId) {
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('modal', 'warranty-history');
        currentUrl.searchParams.set('id', this.historyId);
        window.history.pushState(null, '', currentUrl.toString());
      }
    },
    removeUrlModal() {
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.delete('modal');
      currentUrl.searchParams.delete('id');
      window.history.replaceState(null, '', currentUrl.toString());
    },
    handleModalFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const modal = urlParams.get('modal');
      const historyId = urlParams.get('id');

      if (modal === 'warranty-history' && historyId) {
        this.$emit('open-modal', historyId);
      }
    },
    handlePopState() {
      const urlParams = new URLSearchParams(window.location.search);
      const modal = urlParams.get('modal');

      if (modal !== 'warranty-history' && this.showModal) {
        this.showModal = false;
      }
    },
    handleEscKey(event) {
      if (event.key === 'Escape' && this.showModal) {
        this.showModal = false;
      }
    },
  },
};
</script>

<style scoped>
.bold-text {
  font-weight: bold;
}
.header-color {
  color: #3f4254;
  font-weight: 500;
}
.mb-10 {
  margin-bottom: 2rem;
}
</style>
